export const sanitizeHtmlMessage = (value) => {
  const temp = document.createElement("div")
  temp.innerHTML = value
  let found = null
  for (const key in temp.children) {
    const child = temp.children[key]
    if (child.innerHTML && child.innerHTML.toString().trim() !== '<br>' && child.innerHTML.toString().trim().length > 0) {
      found += child.innerHTML.toString()
    }
  }
  return temp.textContent.trim() || temp.innerText.trim() || found
}
